import { NotificationSettings } from "globalConstants";
import { NotificationSettingsDtoType } from "types";

const { Id, AllowedNotifications } = NotificationSettings;

export const mapNotificationSettingsDataFromServer = (
	data: NotificationSettingsDtoType,
) => {
	return {
		[Id.name]: data[Id.beName],
		[AllowedNotifications.name]: data[AllowedNotifications.beName],
	};
};
